import Toggleable from '../../../mixins/toggleable'
import DialogConfigs from '../dialog-configs'

export default {
  mixins: [ Toggleable ],

  props: {
  	title: { type: String, default: 'Are you sure?' },
  	cancel: { type: String, default: 'Cancel' },
  	confirm: { type: String, default: 'Yes' },
  	confirmIsDestructive: { type: Boolean, default: true },
  },

  computed: {
  	nandosStyle() {
  		return DialogConfigs.nandosStyle
  	}
  },
}